export class City {
  constructor(public city: string, public numOfListings: number) {}
}
